import { action, observable } from "mobx";
import React, { createContext, useContext } from "react";
import { shortID } from "src/helpers";
import { DefaultTheme } from "styled-components";

export interface IToastItem {
  uuid?: string;
  title?: React.ReactNode;
  message: React.ReactNode;
  content?: React.ReactNode;
  timeout?: number;
  persistent?: boolean;
  color?: keyof DefaultTheme["colors"]["background"];
}

export const TOAST_DEFAULT_TIMEOUT = 5000;

export class ToastStore {
  @observable
  $toastItems: IToastItem[] = [];

  showToast = (alert: IToastItem): IToastItem => {
    const toastWithID = { ...alert, uuid: shortID() };
    this.$toastItems.push(toastWithID);
    if (!toastWithID.persistent) {
      this.trackAndDestroyAlert(toastWithID);
    }
    return toastWithID;
  };

  trackAndDestroyAlert = (alert: IToastItem) => {
    setTimeout(() => {
      this.closeById(alert.uuid!);
    }, alert.timeout || TOAST_DEFAULT_TIMEOUT);
  };

  @action
  closeById = (uuid: string) => {
    this.$toastItems.forEach((__alert, index) => {
      if (uuid === __alert.uuid) {
        this.$toastItems.splice(index, 1);
      }
    });
  };
}

export const ToastStoreContext = createContext(new ToastStore());

export const useToastStore = () => useContext(ToastStoreContext);
